import axios from 'axios';
import qs from 'qs';

import {api} from './api';

const wristbandService = axios.create({
    baseURL: 'https://console.airdisk.cc',//设置为空
    timeout: 6000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
        "Access-Control-Allow-Origin": "*"
    }
})


export function request(url, methods, body, successCallBack, errorCallBack) {
    wristbandService({                  // 请求
        url: url,     //此处请求的url
        method: methods,
        data: body
    }).then(res => {
        if (res.data.code === 0) {
            if (successCallBack) {
                successCallBack(res.data.data)
            }
        }else {
            errorCallBack(res.data)
        }

    }).catch(err => {
        console.log(url + '请求错误' + err);
    })
}


// export {wristbandService as Http}


//
// // 请求时的拦截
// axios.interceptors.request.use(function (config) {
//     // 发送请求之前做一些处理
//     // config.headers['Authorization'] = window.localStorage.getItem('token');
//
//     return config;
// }, function (error) {
//     // 当请求异常时做一些处理
//     console.log("请求异常处理：" + error);
//     return Promise.reject(error);
// });
//
// // 响应时拦截
// axios.interceptors.response.use(function (response) {
//     // 返回响应时做一些处理
//     // console.log('返回响应:' + JSON.stringify(response));
//     return response;
// }, function (error) {
//     // 当响应异常时做一些处理
//     console.log('当响应异常时:' + error);
//     return Promise.reject(error);
// });
//
// //设置默认请求头
// axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
//
// axios.defaults.timeout = 30000;
//
// export default {
//     //get请求
//     get(url, param, successCallBack, isLoading) {
//
//         //是否显示loading
//         // if (isLoading) {}
//
//         let apiUrl = api + url;
//         let _this = this;
//
//         axios.get(apiUrl, {params: param, headers: {}}).then(res => {
//             console.log(apiUrl + '返回结果: ');
//             // if (isLoading) {
//             // }
//
//             _this.resultHandle(res.data, successCallBack)
//         }).catch(err => {
//             console.log(err);
//             console.log(apiUrl + '请求错误');
//             // if (isLoading) {
//             // }
//         })
//     },
//
//     //post请求
//     post(url, param, successCallBack, isLoading, errCallBack) {
//         //是否显示loading
//         // if (isLoading) {}
//
//         console.log('请求参数' + JSON.stringify(param));
//         let apiUrl = api + url;
//         let _this = this;
//
//         axios.post(apiUrl, qs.stringify(param), {headers: {}}).then(res => {
//             // if (isLoading) {}
//             console.log(apiUrl + '返回结果: ');
//             _this.resultHandle(res.data, successCallBack, errCallBack)
//
//         }).catch(err => {
//             console.log(err);
//             console.log(apiUrl + '请求错误');
//             // if (isLoading) {}
//         })
//     },
//
//     //返回结果处理
//     resultHandle(res, successCallBack, errCallBack) {
//         console.log(res);
//
//         // if (res.app_result_key === '0') {
//         //   successCallBack(res);
//         // } else if(res && res.result){
//         //   successCallBack(res);
//         // } else {
//         //   if (res.app_result_message_key) {
//         //     showToast(res.app_result_message_key)
//         //   }
//         //   if (res.message) {
//         //     showToast(res.message)
//         //   }
//         //
//         //   if (errCallBack) {
//         //     errCallBack()
//         //   }
//         // }
//
//
//     }
// }
